// plugins/eventBus.js
import mitt from 'mitt';

export default defineNuxtPlugin(() => {
  const eventBus = mitt();

  return {
    provide: {
      eventBus,
    },
  };
});

// EMIT
// $eventBus.emit('page:enter');

// USE IN TEMPLATE
// $eventBus.on('page:enter', onPageEnter);
// onUnmounted(() => {
//   $eventBus.off('page:enter', onPageEnter);
// });
